import { FontAwesomeIcon } from "./FontAwesomeIcon"
import { faShareAlt } from "@fortawesome/free-solid-svg-icons"

export const ShareAlt = (props) => {
  return <FontAwesomeIcon faIcon={faShareAlt} {...props} />
}
